"use client";
import { Suspense, ReactNode, useState, useEffect, useRef } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Box, useMediaQuery } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import "@/assets/styles/globals.css";
import "@/assets/styles/layout.css";
import { useTranslation } from "react-i18next";
import { RegularText } from "@/common/texts";
import FooterLayout from "@/components/layout/footer";
import BookingState from "@/context/bookingContext/bookingState";
import FirebaseState from "@/context/firebaseContext/firebaseState";
import { LayoutProvider } from "@/context/layoutContext/layoutProvider";
import SearchState from "@/context/searchContext/searchState";
import SessionAuthProvider from "@/context/SessionAuthProvider";
import { SnackbarProvider } from "@/context/SnackbarContext";
import StoreProvider from "@/context/storeContext";
import { AppUAProvider } from "@/context/uaContext";
import theme from "@/theme/defaultTheme";
import { HEADER_HEIGHT, NEUTRO_BLANK_COLOR } from "@/utils/constants";

export const MainLayoutContent = ({ children }: { children: ReactNode }) => {
  const [isLargeButton, setIsLargeButton] = useState(false);
  const countActions = useRef(0);
  const isMobile = useMediaQuery("(max-width:500px)");
  useEffect(() => {
    if (countActions.current < 2 && !isMobile) {
      if (!isLargeButton) {
        setTimeout(() => {
          setIsLargeButton(true);
          countActions.current = 1;
        }, 20000);
      }
      if (isLargeButton) {
        setTimeout(() => {
          setIsLargeButton(false);
          countActions.current = 2;
        }, 10000);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLargeButton]);
  const { t } = useTranslation();
  return (
    <Suspense>
      <ThemeProvider theme={theme}>
        <LayoutProvider>
          <SnackbarProvider>
            <Box style={{ minHeight: "calc(100vh - " + HEADER_HEIGHT + ")" }}>
              <a
                href="https://api.whatsapp.com/message/EWHCTQFOXHTNF1?autoload=1&app_absent=0"
                className="float"
                target="_blank"
                rel="noreferrer"
                aria-label="Contacta con nosotros por Whatsapp"
              >
                <WhatsAppIcon style={{ fontSize: "27px" }} />
                {isLargeButton && (
                  <RegularText
                    style={{ marginTop: "-3px" }}
                    color={NEUTRO_BLANK_COLOR}
                  >
                    {t("footer.chat")}
                  </RegularText>
                )}
              </a>

              <SessionAuthProvider>
                <SearchState>
                  <FirebaseState>
                    <StoreProvider>
                      <BookingState>
                        <AppUAProvider>{children}</AppUAProvider>
                      </BookingState>
                    </StoreProvider>
                  </FirebaseState>
                </SearchState>
              </SessionAuthProvider>
            </Box>
            <FooterLayout />
          </SnackbarProvider>
        </LayoutProvider>
      </ThemeProvider>
    </Suspense>
  );
};
